const sectorLanguageTypes = {
    1: "he",
    2: "ar",
    4: "ar",
    5: "ar",
    6: "he",
}

export default sectorLanguageTypes;